import { Theme, Components, Palette, PaletteColor } from '@mui/material';

export const LIST_ITEM_HEIGHT = 40;

export default {
  defaultProps: {
    color: 'primary',
    disableGutters: true,
    disableRipple: true,
    'data-test-id': 'option-item'
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const color = theme.palette[ownerState.color as keyof Palette] as PaletteColor;
      return {
        height: LIST_ITEM_HEIGHT,
        borderRadius: 2,
        padding: theme.spacing(1),
        '& .selected-option-icon': {
          marginLeft: 'auto',
        },
        '&.Mui-selected': {
          backgroundColor: color.container,
          '& svg': {
            color: color.main
          },
          ...theme.createStateLayer('transparent'),
        },
        ...theme.createStateLayer('transparent'),
      };
    },
  }
} as Components<Theme>['MuiListItemButton'];

